<template>
  <div class="text-center">
    <v-dialog persistent v-if="visible" v-model="visible" width="800">
      <v-card class="not-margin pt-0 pr-0 pl-0">
        <v-toolbar dark color="primary">
          <div class="text-center">
            <v-icon>mdi-calendar</v-icon>
            {{ edit ? "Editar" : "Cadastrar" }} Calendário
          </div>
        </v-toolbar>
        <div class="container dialog">
          <v-form ref="form">
            <v-row class="mt-7">
              <v-col cols="12">
                <v-text-field
                  v-model="content.nome"
                  label="Nome do Calendário*"
                  outlined
                  dense
                  counter="100"
                  maxlength="100"
                  :rules="[(v) => $required(v)]"
                />
              </v-col>
            </v-row>
            <v-row class="mt-3">
              <v-col cols="6">
                <v-autocomplete
                  v-model="content.anoCalendario"
                  label="Ano Calendário*"
                  item-text="ano"
                  item-value="id"
                  outlined
                  dense
                  :items="$anosCalendarioAntesDepois()"
                  :rules="[(v) => $required(v)]"
                />
              </v-col>
              <v-col cols="6">
                <v-text-field
                  v-model="content.periodo"
                  label="Período do Calendário"
                  outlined
                  dense
                  disabled
                />
              </v-col>
            </v-row>
            <v-row class="mt-3 align-center">
              <v-col cols="6">
                <v-switch
                  v-model="content.vigente"
                  :true-value="true"
                  :false-value="false"
                  label="Tornar Calendário Vigente"
                  inset
                  color="primary"
                  dense
                />
              </v-col>
              <v-col cols="6">
              </v-col>
            </v-row>
          </v-form>
        </div>
        <sca-buttons
          @click="salvar()"
          @cancel="$emit('onClose')"
          :actionText="edit ? 'Editar' : 'Salvar'"
        />
      </v-card>
    </v-dialog>
  </div>
</template>

<script>
import { DialogProps } from '~/commons/classes/dialog-props';
import { Calendario } from '~/commons/classes/calendario';
import CalendarioService from '~/services/calendario.service';

export default {
  props: new DialogProps(Calendario),
  mixins: [CalendarioService],
  data() {
  return {
    desativarVigenciaAnterior: false
  };
},
  methods: {
    salvar() {
      if (!this.$validarFormulario()) return;
      this.verificarVigenciaAntesDeSalvar();
    },
    async verificarVigenciaAntesDeSalvar() {
      this.desativarVigenciaAnterior = false;

      if (this.content.vigente) {
        try {
          const { data } = await this.$verificarVigencia(this.content.anoCalendario);

          if (data.existeCalendarioVigenteParaOano) {
            let confirmacao = false;
            try {
              confirmacao = await this.$swal({
                text: "Já existe um calendário vigente para este ano. Deseja substituir?",
                type: "warning",
                showCancelButton: true,
                confirmButtonText: "Substituir",
                cancelButtonText: "Cancelar",
              });
            } catch {
              return;
            }
            if (!confirmacao) {
              return;
            }
            this.desativarVigenciaAnterior = true;
          }
        } catch (err) {
          this.$notifyError("Erro ao verificar vigência.");
          console.error(err);
          return;
        }
      }
      this.confirmarESalvar();
    },

    async confirmarESalvar() {
      const calendario = new Calendario(this.content).format();

      calendario.desativarVigenciaCalendarioAnterior = this.desativarVigenciaAnterior;

      let confirmacao;
      try {
        confirmacao = await this.$swal({
          text: `Deseja ${this.edit ? "editar" : "cadastrar"} o registro?`,
          type: "warning",
          showCancelButton: true,
          confirmButtonText: `Confirmar`,
          cancelButtonText: `Cancelar`,
        });
      } catch {
        return;
      }

      if (!confirmacao) return;

      try {
        const resposta = this.edit
          ? await this.$editarCalendario(calendario, calendario.id)
          : await this.$cadastrarCalendario(calendario);

        this.$notifySuccess(resposta.data.mensagem);
        this.$emit("onClose");
        this.$emit("onSave");
      } catch ({data}) {
        this.$notifyError(data.mensagem);
      }
    }




  },
  mounted() {
    this.content.periodo = "Anual";
  },
};
</script>
